import { FontFamily } from '@common/theming/Fonts';
import { Palette } from '@common/theming/Palette';
import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import { TextBlock } from '../TextBlock';

export const Timeline: React.FC<AssetBlockProps> = ({ asset }) => {
  return (
    <div>
      <div style={{ marginTop: 36 }}>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1, marginTop: -18 }}>
            {asset.timeLine?.events.map((event, i) => {
              return (
                <div key={`timelineItemLeft-${i}`} style={{ height: 40 }}>
                  {i % 2 === 0 ? (
                    <>
                      <TextBlock
                        color={Palette.BLACK}
                        size={16}
                        style={{ marginRight: 24, marginTop: i === 0 ? 0 : 100, textAlign: 'end' }}>
                        {event.label}
                      </TextBlock>
                      <TextBlock color={Palette.BLUE} style={{ marginRight: 24, textAlign: 'end' }}>
                        {event.date}
                      </TextBlock>
                    </>
                  ) : (
                    <div
                      style={{
                        height: 40,
                        marginTop: i === 0 ? 0 : 100,
                      }}></div>
                  )}
                </div>
              );
            })}
          </div>
          <div>
            <div
              style={{
                background: 'linear-gradient(180deg, #171F2A 0%, #308EFF 100%)',
                height: ((asset.timeLine?.events.length || 0) - 1) * 140,
                width: 4,
              }}>
              {asset.timeLine?.events.map((_, i) => {
                return (
                  <div key={`timelineDot-${i}`} style={{ height: 40 }}>
                    <div
                      style={{
                        backgroundColor: Palette.WHITE,
                        border: `2px solid ${Palette.BLUE}`,
                        borderRadius: 15,
                        height: 16,
                        marginLeft: -6,
                        marginTop: i === 0 ? 0 : 100,
                        width: 16,
                      }}></div>
                  </div>
                );
              })}
            </div>
          </div>

          <div style={{ flex: 1, marginTop: -18 }}>
            {asset.timeLine?.events.map((event, i) => {
              return (
                <div key={`timelineItemRight-${i}`} style={{ height: 40, paddingLeft: 24 }}>
                  {i % 2 === 1 ? (
                    <>
                      <div
                        style={{
                          color: Palette.BLACK,
                          fontFamily: FontFamily.NEUE_HAAS_DISPLAY_ROMAN,
                          fontSize: 16,
                          letterSpacing: 0.5,
                          lineHeight: 1.5,
                          marginTop: i === 0 ? 0 : 100,
                        }}>
                        {event.label}
                      </div>
                      <div
                        style={{
                          color: Palette.BLUE,
                          fontFamily: FontFamily.NEUE_HAAS_DISPLAY_ROMAN,
                          fontSize: 12,
                          letterSpacing: 0.5,
                          lineHeight: 1.5,
                        }}>
                        {event.date}
                      </div>
                    </>
                  ) : (
                    <div
                      style={{
                        height: 40,
                        marginTop: i === 0 ? 0 : 100,
                        width: '100%',
                      }}></div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
